import { createStore, applyMiddleware, compose } from 'redux';
// @ts-expect-error Untyped module
import NotificationMiddleware from 'ReduxMessenger/middleware/NotificationMiddleware';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const createStoreWithMiddleware = composeEnhancers(applyMiddleware(NotificationMiddleware, thunk))(createStore);
export default function configureStore(initialState = {}) {
  return createStoreWithMiddleware(rootReducer, initialState);
}